<template>
  <vs-popup full-screen class="shipment-delivery-note-pop-up"
            id="popup"
            :title="`${formulation_code} Specification Document`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="24">
          <pdf ref="myPdfComponent" class="object-scale-down" :src="file" ></pdf>
        </vs-col>
      </vs-row>

      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click="onClickDownload" button="submit" icon-pack="feather" icon="icon-download-cloud" color="primary" class="ml-auto mt-2">Download</vs-button>
        <vs-button @click="onClickPrint" button="submit" icon-pack="feather" icon="icon-printer" color="danger" class="ml-2 mt-2">Print</vs-button>
      </div>

      <span style="display: none">{{file}}</span>
    </vx-card>
  </vs-popup>
</template>

<script>
  import pdf from 'vue-pdf'
  import axios from "@/axios";
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      formulation_code: '',
      formulation_name: '',
      spec_type: '',
      file: ''
    }
  }

  export default {
    name: 'ProductSpecificationDocumentPopUp',
    data () {
      return initialState()
    },
    methods:{
      onClickPrint() {
        if (!this.file) return;
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        iframe.src = this.file;
        document.body.appendChild(iframe);
        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          }, 100);
        };
      },
      async onClickDownload() {
        const link = document.createElement('a');
        link.href = this.file;
        let file_name =  this.formulation_code + ' ' + this.formulation_name
        link.download = this.spec_type === 'provisional-product-specification-pdf' ? file_name + ' Provisional Specifcation.pdf' : file_name + ' Product Specifcation.pdf' 
        link.click();
      },
      async openPopup (id, formulation_code, formulation_name, spec_type) {
        try {
          await Object.assign(this.$data, initialState())
          this.formulation_code = formulation_code
          this.formulation_name = formulation_name
          this.spec_type = spec_type
          this.id = id
          await this.getRmOrderItemLabel(spec_type)
        } catch (error) {

        }
      },
      async getRmOrderItemLabel(spec_type) {
        try {
          axios(`admin/formulation/${this.id}/${spec_type}`, {
            method: 'GET',
            responseType: 'blob',
          })
            .then(response => {
              //Create a Blob from the PDF Stream
              const file = new Blob(
                [response.data],
                {type: 'application/pdf'});
              //Build a URL from the file
              this.file = URL.createObjectURL(file)
              this.open = true;
              this.$vs.loading.close()
              //Open the URL on new Window
            }).catch(error =>  {
            this.showErrorMessage('Something went wrong. Please contact admin!')
          })
        } catch (e) {
          this.open = false
        }
      },
    },
    components: {
      pdf
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .shipment-delivery-note-pop-up >>> .vs-popup {
    /*min-height: 78% !important;*/
    /*min-width: 60% !important;*/
  }

</style>
